import { DEFAULT_DOOR_OFFGROUND, DEFAULT_WINDOW_OFFGROUND } from '@/editor/constant/entity';
import { EDoorWindowSide, EDoorWindowType } from '@/editor/data/model/model';
import { globalStores } from '@/editor/stores';
import { EToolType } from '@/editor/types';
import { getUniqueId } from '@/editor/utils';

export function getDoorWindowType() {
  let type = EDoorWindowType.window;
  switch (globalStores.operateInfo.toolType) {
    case EToolType.window:
      type = EDoorWindowType.window;
      break;
    case EToolType.frenchWindow:
      type = EDoorWindowType.frenchWindow;
      break;
    case EToolType.singleDoor:
      type = EDoorWindowType.singleDoor;
      break;
    case EToolType.doubleDoor:
      type = EDoorWindowType.doubleDoor;
      break;
    case EToolType.motherDoor:
      type = EDoorWindowType.motherDoor;
      break;
  }
  return type;
}

export function getDefaultDoorWindowData() {
  const type = getDoorWindowType();
  const modelStore = globalStores.modelStore;
  const modelId = modelStore.getWindowDoorDefaultBrandGoodId(type);
  const modelInfo = modelStore.getModel(modelId);
  const width = modelInfo?.properties.width ?? 1000;
  const height = modelInfo?.properties.height ?? 2000;

  return {
    id: getUniqueId(),
    width,
    height,
    offGround: type === EDoorWindowType.window ? DEFAULT_WINDOW_OFFGROUND : DEFAULT_DOOR_OFFGROUND,
    type,
    relativeWallInfo: { relativeWallId: '' },
    side: EDoorWindowSide.right,
    flip: false,
    distance: 0,
    modelId: modelId,
    center: { x: 0, y: 0 },
    rotation: 0,
    thickness: 100
  };
}
